import { render, staticRenderFns } from "./xunjiang-project-audit.vue?vue&type=template&id=2c4407f0&scoped=true"
import script from "./xunjiang-project-audit.vue?vue&type=script&lang=js"
export * from "./xunjiang-project-audit.vue?vue&type=script&lang=js"
import style0 from "./xunjiang-project-audit.vue?vue&type=style&index=0&id=2c4407f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4407f0",
  null
  
)

export default component.exports